import styles from './TabSection.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class TabSection extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    render() {
        const container = document.createElement('div');
        container.innerHTML = `
            <div class="base-grid">
                <div class="overline"></div>
                <div class="title"></div>
            </div>
            <slot></slot>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneSlotContentIntoContainer(container.querySelector('.overline'), 'overline');
        this.cloneSlotContentIntoContainer(container.querySelector('.title'), 'title');
        return container;
    }

}

customElements.define('nxt-tab-section', TabSection);
